import './kp-availability-button.less';
import type {IOnInit, IQService} from 'angular';
import * as angular from 'angular';
import Choose from '../../../../shared/utils/choose';
import type {CapabilityName, DocumentAvailability} from 'typings/portaro.be.types';
import type {Component, OnChangesObject} from 'typings/portaro.fe.types';

export abstract class AvailabilityButtonComponentController implements AvailabilityButtonComponentBindings, IOnInit {
    public av: DocumentAvailability | Promise<DocumentAvailability>;
    public forExemplar: boolean;
    public size: 'lg' | 'md' | 'sm';
    public block: boolean;

    public availability: DocumentAvailability;
    public cssClasses: string[];

    /*@ngInject*/
    constructor(private $q: IQService) {
    }

    public abstract request();

    public choose: Choose;

    public $onInit(): void {
        this.size = this.size || 'md';
        this.block = !!this.block;
        this.choose = new Choose();
    }

    public $onChanges(onChangesObj: OnChangesObject<AvailabilityButtonComponentBindings>): void {
        if (onChangesObj.av && onChangesObj.av.currentValue) {
            this.$q.when(onChangesObj.av.currentValue)
                .then((availability) => {
                    this.availability = availability;
                    this.generateCssClasses();
                });
        }
    }

    public isCapableOfOneOf(...capabilityNames: CapabilityName[]): boolean {
        if (this.availability && angular.isDefined(this.availability.capabilities)) {
            return capabilityNames.some((capabilityName) => this.availability.capabilities.some((cap) => cap.name === capabilityName));
        }
        return false;
    }


    private generateCssClasses(): string[] {
        if (!this.availability) {
            return;
        }

        this.cssClasses = [];

        const addCssClassIf = (condition: boolean, cssClass: string, ...otherwiseCssClass: string[]) => {
            if (condition) {
                this.cssClasses.push(cssClass);
            } else if (otherwiseCssClass) {
                this.cssClasses.push(...otherwiseCssClass);
            }
        };

        this.cssClasses.push(`btn-${this.size}`);

        addCssClassIf(this.block, 'btn-block');
        addCssClassIf(this.forExemplar, 'availability-button-exemplar', 'availability-button-document');
        addCssClassIf(this.availability.reasonable, 'reasonable', 'not-reasonable');
        addCssClassIf(this.availability.capabilities.length > 0, 'available btn-success', 'not-available btn-danger');

        addCssClassIf(this.isCapableOfOneOf('pickupability', 'visitPickupability'), 'pickable', 'not-pickable');
        addCssClassIf(this.isCapableOfOneOf('standardOrderability', 'standardVisitOrderability'), 'orderable', 'not-orderable');
        addCssClassIf(this.isCapableOfOneOf('standardReservability', 'standardVisitReservability'), 'reservable', 'not-reservable');
        addCssClassIf(this.isCapableOfOneOf('downloadability'), 'downloadable', 'not-downloadable');
        addCssClassIf(this.isCapableOfOneOf('mailRequestability'), 'mail-requestable', 'not-mail-requestable');
        addCssClassIf(this.isCapableOfOneOf('mvsRequestability'), 'mvs-requestable', 'not-mvs-requestable');
        addCssClassIf(this.isCapableOfOneOf('ereadingLoanability'), 'ereading-loanable', 'not-ereading-loanable');
        addCssClassIf(this.isCapableOfOneOf('flexibooksLoanability'), 'flexibooks-loanable', 'not-flexibooks-loanable');
        addCssClassIf(this.isCapableOfOneOf('levnaknihovnaLoanability'), 'levnaknihovna-loanable', 'not-levnaknihovna-loanable');
    }
}

/**
 * @ngdoc component
 * @module portaro.components.loan
 * @name kpAvailabilityButton
 *
 * @param {DocumentAvailability} kpAvailability Availability object
 * @param {boolean} kpForExemplar Is for exemplar?
 * @param {function()} kpOnRequest Same as ngClick
 * @param {string} [kpSize='md'] Bootstrap button size ('lg', 'md', 'sm')
 * @param {boolean} [kpBlock=false] Should be button block element or not (inline)?
 */
// eslint-disable-next-line
export default class AvailabilityButtonComponent implements Component<AvailabilityButtonComponentBindings> {
    public static componentName = 'kpAvailabilityButton';

    public templateUrl = require('./kp-availability-button.tpl.ftl');

    // @ts-ignore Needs more refactoring of usage this component. Not too important now.
    public bindings = {
        av: '<kpAvailability',
        forExemplar: '<kpForExemplar',

        request: '&kpOnRequest',

        size: '@kpSize',
        block: '@kpBlock'
    } as const;

    public controller = AvailabilityButtonComponentController;
}

interface AvailabilityButtonComponentBindings {
    av: DocumentAvailability | Promise<DocumentAvailability>;
    forExemplar: boolean;
    size: 'lg' | 'md' | 'sm';
    block: boolean;

    request();
}
